<template>
  <a :href="data.url" :title="data.filename" target="_blank" download>
    {{ title }}
  </a>
</template>

<script>
//import WpLink from "@/components/elements/WpLink";

export default {
  name: "acf-file",
  props: ["data"],
  computed: {
    title() {
      let title = "";
      if (this.data.title === "") {
        title = "View ...";
      } else {
        title = this.data.title;
      }
      if (this.$slots.default) {
        title =
          '<span class="text">' +
          title +
          "</span>" +
          '<span class="slot">' +
          this.$slots.default[0].text +
          "</span>";
      }
      return title;
    }
  },
  methods: {
    forceDownload(filename, text) {
      let element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    }
  },
  components: {
    //WpLink
  }
};
</script>
